import React, { useState, useEffect } from "react";
import '../styles/ClientDebtSummary.css'; // Optional, for styling
import Swal from 'sweetalert2';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { formatCurrencyUSD } from "../utils/format";

const ClientDebtSummary = () => {
  // State to store the data and sort direction
  const [data, setData] = useState([]);
  const [depositData, setDepositData] = useState({});
  const [settlementData, setSettlementData] = useState({});
  const [accountBalData, setAccountBalData] = useState(null);
  const [transactionDataWDebtID, setTransactionDataWDebtID] = useState({});
  const [transactionDataWODebtID, setTransactionDataWODebtID] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState(null);
  const [clientid, setClientid] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalTransactionOpen, setIsModalTransactionOpen] = useState(false);
  const [isModalRecalculationFeeOpen, setIsModalRecalculationFeeOpen] = useState(false);
  const [isModalRecalculationFeesOpen, setIsModalRecalculationFeesOpen] = useState(false);
  const [isModalRecalculationSettlementOpen, setIsModalRecalculationSettlementOpen] = useState(false);

  const [selectedDebt, setSelectedDebt] = useState(null);
  const [calculatorType, setCalculatorType] = useState("1");
  const [feeCollectionType, setFeeCollectionType] = useState("1");


  const [selectedTableNameFilter, setSelectedTableNameFilter] = useState("All");
  const [uniqueTableNames, setUniqueTableNames] = useState([]);

  const [selectedStatusFilter, setSelectedStatusFilter] = useState("All");
  const [uniqueStatuses, setUniqueStatuses] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  // Handler to clear all filters
  const clearFilters = () => {
    setSelectedTableNameFilter("All");
    setSelectedStatusFilter("All");
    setDateFrom('');
    setDateTo('');
  };


  // const TabPanel = ({ children, value, index }) => {
  //   return (
  //     <div hidden={value !== index}>
  //       {value === index && (
  //         <Box p={2}>
  //           <Typography>{children}</Typography>
  //         </Box>
  //       )}
  //     </div>
  //   );
  // };

  
const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          {typeof children === 'string' ? (
            <Typography>{children}</Typography>
          ) : (
            children
          )}
        </Box>
      )}
    </div>
  );
};

 const TableNameFilterDropdown = ({ selectedFilter, onChange, options }) => {
    //alert(onChange);
    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '140px', marginBottom: '10px', marginLeft: '10px' }}>
        <label style={{ fontSize: '1em', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
          Filter by Transaction
        </label>
        <select
          value={selectedFilter}
          onChange={(e) => onChange(e.target.value)}
          style={{
            border: '1px solid #D1D5DB',
            borderRadius: '7px',
            padding: '10px',
            fontSize: '1em',
            backgroundColor: 'white',
            cursor: 'pointer',
            width: '300px'
          }}
        >
          {options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    );
  };


  const StatusFilterDropdown = ({ selectedFilter, onChange, options }) => {
    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '140px', marginBottom: '10px', marginLeft: '10px' }}>
        <label style={{ fontSize: '1em', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
          Filter by Status
        </label>
        <select
          value={selectedFilter}
          onChange={(e) => onChange(e.target.value)}
          style={{
            border: '1px solid #D1D5DB',
            borderRadius: '7px',
            padding: '10px',
            fontSize: '1em',
            backgroundColor: 'white',
            cursor: 'pointer',
            width: '300px'
          }}
        >
          {options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    );
  };

  const filterByDateRange = (data, from, to) => {
    if (!from && !to) return data;
    return data.filter(item => {
      if (item.ClearedDate === 'N/A') return false;
      const date = new Date(item.ClearedDate);
      const fromDate = from ? new Date(from) : null;
      const toDate = to ? new Date(to) : null;
      if (fromDate && date < fromDate) return false;
      if (toDate && date > toDate) return false;
      return true;
    });
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  }

  const calculateFeeAllocation = () => {
    if (!selectedDebt) return [];

    const startBalance = accountBalData;
    const monthlyDeposit = depositData;
    const feeDue = parseFloat(selectedDebt.scheduledFee || 0);
    const settlementSchedule = settlementData;

    let feeRemaining = feeDue;
    let balance = startBalance;

    const feeLog = [];
    const today = new Date();

    for (let m = 0; m < settlementSchedule.length; m++) {
      balance += monthlyDeposit[m];

      // Deduct current month settlement
      const currentSettlement = settlementSchedule[m] || 0;
      balance -= currentSettlement;

      // Calculate future shortfalls (beyond this month)
      let futureShortfall = 0;
      for (let i = m + 1; i < settlementSchedule.length; i++) {
        const shortfall = settlementSchedule[i] - (monthlyDeposit[i] || 0);
        if (shortfall > 0) {
          futureShortfall += shortfall;
        }
      }

      // Reserve future obligations (but don’t reduce balance below zero)
      const reserve = Math.min(balance, futureShortfall);
      balance -= reserve;

      // Pay as much fee as possible with remaining balance (still keeping balance >= 0)
      const feePayment = Math.max(0, Math.min(balance, feeRemaining));
      feeRemaining -= feePayment;
      balance -= feePayment;

      const scheduledDate = new Date(today);
      scheduledDate.setMonth(today.getMonth() + m);

      feeLog.push({
        month: m + 1,
        feeCollected: parseFloat(feePayment.toFixed(2)),
        remainingFee: parseFloat(feeRemaining.toFixed(2)),
        remainingBalance: parseFloat(balance.toFixed(2)),
        scheduleDate: scheduledDate.toLocaleDateString('en-US', {
          year: 'numeric', month: 'short', day: 'numeric'
        })
      });

      if (feeRemaining <= 0) break;
    }

    // Continue into future months if fee is still not paid
    let extraMonth = settlementSchedule.length;
    while (feeRemaining > 0) {
      balance += monthlyDeposit[0]; // assume deposit continues at same rate

      const feePayment = Math.max(0, Math.min(balance, feeRemaining));
      feeRemaining -= feePayment;
      balance -= feePayment;

      const scheduledDate = new Date(today);
      scheduledDate.setMonth(today.getMonth() + extraMonth);

      feeLog.push({
        month: extraMonth + 1,
        feeCollected: parseFloat(feePayment.toFixed(2)),
        remainingFee: parseFloat(feeRemaining.toFixed(2)),
        remainingBalance: parseFloat(balance.toFixed(2)),
        scheduleDate: scheduledDate.toLocaleDateString('en-US', {
          year: 'numeric', month: 'short', day: 'numeric'
        })
      });

      extraMonth++;
    }

    // Trim any trailing entries with no fee collected
    let lastValidIndex = feeLog.length - 1;
    while (lastValidIndex >= 0 && feeLog[lastValidIndex].feeCollected === 0) {
      lastValidIndex--;
    }

    return feeLog.slice(0, lastValidIndex + 1);
  };



  const recalculateFees = (feeCollectionType) => {

    //alert("CollectionType: " + feeCollectionType);
    const today = new Date();
    const maxMonths = 60;
    const monthlyDeposit = depositData;
    const schedule = settlementData;
    let globalBalance = accountBalData;

    // Sort debts according to selected strategy
    const debtOrder = data
      .filter(d => parseFloat(d.scheduledFee) > 0)
      .sort((a, b) => {
        const feeA = parseFloat(a.scheduledFee || 0);
        const feeB = parseFloat(b.scheduledFee || 0);

        switch (feeCollectionType) {
          case '1': return feeB - feeA; // Highest scheduledFee first
          case '2': return feeA - feeB; // Lowest scheduledFee first
          case '3': return String(a.debtId).localeCompare(String(b.debtId)); // Equal or natural order
          case '4': return (a.priority || 0) - (b.priority || 0); // Custom priority
          default: return 0;
        }
      });

    //alert("pendingFee first: " + debtOrder[0].debtId);

    let globalMonthIndex = 0;

    const results = debtOrder.map((debt) => {
      const debtId = debt.debtId;
      const creditor = debt.creditorName;
      let feeRemaining = parseFloat(debt.scheduledFee || 0);
      const feeLog = [];

      let localMonthIndex = globalMonthIndex;
      let monthsUsed = 0;

      while (feeRemaining > 0 && monthsUsed < maxMonths && localMonthIndex < maxMonths) {
        const deposit = monthlyDeposit[localMonthIndex] ?? monthlyDeposit[0] ?? 0;
        const outflow = schedule[localMonthIndex] ?? 0;

        globalBalance += deposit;
        globalBalance -= outflow;

        // --- Estimate future obligations (shortfalls only) ---
        let futureObligations = 0;
        for (let i = localMonthIndex + 1; i < schedule.length; i++) {
          const futureShortfall = (schedule[i] ?? 0) - (monthlyDeposit[i] ?? monthlyDeposit[0] ?? 0);
          if (futureShortfall > 0) futureObligations += futureShortfall;
        }

        // --- Prevent balance from dropping below what’s needed for future settlements ---
        let availableForFee = globalBalance - futureObligations;
        if (availableForFee < 0) availableForFee = 0;

        const feePayment = Math.min(availableForFee, feeRemaining);
        feeRemaining = parseFloat((feeRemaining - feePayment).toFixed(2));
        globalBalance = parseFloat((globalBalance - feePayment).toFixed(2));

        const scheduledDate = new Date(today);
        scheduledDate.setMonth(today.getMonth() + localMonthIndex);

        feeLog.push({
          debtId,
          creditor,
          month: monthsUsed + 1,
          feeCollected: parseFloat(feePayment.toFixed(2)),
          remainingFee: feeRemaining,
          remainingBalance: globalBalance,
          scheduleDate: scheduledDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }),
          scheduleDateObj: scheduledDate,
        });
        // Move to next month
        localMonthIndex++;
        monthsUsed++;
      }


      // Advance global index so the next debt starts from the next available month
      globalMonthIndex = localMonthIndex;

      return feeLog.some(entry => entry.feeCollected > 0)
        ? {
            debtId,
            creditor,
            scheduledFee: parseFloat(debt.scheduledFee || 0),
            pendingFee: parseFloat(debt.pendingFee || 0),
            feeSchedule: feeLog
          }
        : null;
    }).filter(Boolean);


    //alert("debt ID: " +results[0].debtId);

    return results;
  };

    
  const getDebtDetailsTransactionsWDebtID  = () => {
    if (!selectedDebt) return [];

    const debtID = selectedDebt.debtId; 
    const debtDetailedTransWDebtID = transactionDataWDebtID;
    const transLog = [];

    for (let m = 0; m < debtDetailedTransWDebtID.length; m++) {
      //alert(debtDetailedTrans[m].DebtId);
      if (debtDetailedTransWDebtID[m].DebtId  === debtID) {
        const formattedDateScheduleDateAdjusted = debtDetailedTransWDebtID[m].ScheduleDateAdjusted ? debtDetailedTransWDebtID[m].ScheduleDateAdjusted.split('T')[0] : 'N/A';
        transLog.push({
          ID: debtDetailedTransWDebtID[m].ID,
          TransactionDate: formattedDateScheduleDateAdjusted,
          TableName: debtDetailedTransWDebtID[m].TableName,
          Amount: debtDetailedTransWDebtID[m].Amount,
          TransactionStatus: debtDetailedTransWDebtID[m].TransactionType
          });
      }
    } 

    return transLog;
  };

  const [resultTrans, setResultTrans] = useState([]);
    
  const getDebtDetailsTransactionsWODebtID  = (debtDetailedTrans) => {
      const transLog = [];
      let counterID = 1;

      // ✅ Step 1: Sort input array by ScheduleDateAdjusted (ClearedDate)
      const sortedDebtTrans = [...debtDetailedTrans].sort((a, b) => {
        const dateA = a.ScheduleDateAdjusted ? new Date(a.ScheduleDateAdjusted) : new Date(0); // fallback for nulls
        const dateB = b.ScheduleDateAdjusted ? new Date(b.ScheduleDateAdjusted) : new Date(0);
        return dateA - dateB; // ascending order
      });

      // ✅ Step 2: Process sorted data
      for (let m = 0; m < sortedDebtTrans.length; m++) {
        const item = sortedDebtTrans[m];

        const formattedDateScheduleDateOriginal = item.ScheduleDateOriginal
          ? item.ScheduleDateOriginal.split('T')[0]
          : 'N/A';

        const formattedDateScheduleDateAdjusted = item.ScheduleDateAdjusted
          ? item.ScheduleDateAdjusted.split('T')[0]
          : 'N/A';

        transLog.push({
          CounterID: counterID++,
          DebtID: item.DebtId,
          TransID: item.ID,
          ProcessDate: formattedDateScheduleDateOriginal,
          ClearedDate: formattedDateScheduleDateAdjusted,
          TableName: item.TableName,
          Amount: item.Amount,
          Type: item.Type,
          TransactionStatus: item.TransactionStatus,
        });
      }

      return transLog;
  };

    const [results, setResults] = useState([]);
  
    const handleClick = () => {
      // const allocation = calculateFeeAllocation();
      // setResults(allocation);
      Swal.fire({
              title: "Processing...",
              text: `Sample`,
              timer: 1500,
              showConfirmButton: false,
              willClose: () => {}, // optional callback
              })
    };
    
    const handleClickTransactionsWODebtID = () => {
      const allocation = getDebtDetailsTransactionsWODebtID();
      setResultTrans(allocation);
    };

    const handleClickTransactionsWDebtID = () => {
      const allocation = getDebtDetailsTransactionsWDebtID();
      setResults(allocation);
    };

    const handleClickFeeRecalculation = () => {
      const allocation = calculateFeeAllocation();
      setResults(allocation);
    };

    const handleClickFeesRecalculation = () => {
      const allocation = recalculateFees(feeCollectionType);
      setResults(allocation);
    };


    

  const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;
  
    return (
      <div className="modal-overlay">
        <div className="modal">
          <button className="modal-close" onClick={onClose}>×</button>
          <div className="modal-content">{children}</div>
        </div>
      </div>
    );
  };

  // Check for client-id continuously until it is found
  useEffect(() => {
  const observeChanges = () => {
    const cftidElement = document.getElementById('client-id');
    const dmidElement = document.getElementById('external-id');
    const forthidElement = document.getElementById('contact-id');
    const balanceIdElement = document.getElementById('balance-id');

    const getValidClientId = () => {
      const cftid = cftidElement?.innerText.trim();
      const dmid = dmidElement?.innerText.trim();
      const forthid = forthidElement?.innerText.trim();

      const ids = [forthid, cftid, dmid];
      return ids.find(id => id && id !== '0' && id !== 0) || 0;
    };

    const handleChange = () => {
      const foundClientid = getValidClientId();

      if (foundClientid && foundClientid !== '0') {
        setClientid(foundClientid);

        if (balanceIdElement) {
          const foundBalance = Number(
            balanceIdElement.innerText.trim().replace('$', '').replace(/,/g, '')
          );
          setAccountBalData(foundBalance);
        }
      }
    };

    const observer = new MutationObserver(handleChange);
    const config = { childList: true, subtree: true, characterData: true };

    if (cftidElement) observer.observe(cftidElement, config);
    if (dmidElement) observer.observe(dmidElement, config);
    if (forthidElement) observer.observe(forthidElement, config);

    return () => {
      observer.disconnect(); // Clean up when component unmounts
    };
  };

  observeChanges();
}, []);


 


  // Fetch data once the client-id is available
  useEffect(() => {
    if (!clientid || clientid === '0') return; // Do not fetch until clientid is found
    
      const fetchData = async () => {
        try {
          //setLoading(true);
          setIsVisible(true); // Show loading data section
          const [validateRes, depositRes,settlementRes, transResWDebtID, transResWODebtID] = await Promise.all([
            fetch(`https://eokyvyhqmpmj3tg.m.pipedream.net/api/CompletionCalculator/GetDebtSummaryByClientID?clientid=${clientid}`),
            fetch(`https://eobh77ln4dd2s3d.m.pipedream.net/api/CompletionCalculator/GetMonthlyDepositByClientID?clientid=${clientid}`),
            fetch(`https://eoxjblgkawmt9nv.m.pipedream.net/api/CompletionCalculator/GetMontlySettlementByClientID?clientid=${clientid}`),
            //fetch(`https://eoe1aat9024160r.m.pipedream.net/api/GetDraftAmountBalanceByClientID?clientid=${clientid}`), 
            //fetch(`https://eorosh5jp5o0uqj.m.pipedream.net/api/GetBalancesByContactID?contact_id=${contactIDText}`),
            fetch(`https://eo7x1rfl51lpefl.m.pipedream.net/api/CompletionCalculator/GetDebtDetailsByClientID?clientid=${clientid}`),
            fetch(`https://eofozbdypqweofp.m.pipedream.net/api/DebtSettlementCalculator/GetAllTransactionsWODebtIDByClientID?clientid=${clientid}`)
          ]);
  
          const validateData = await validateRes.json();
          const depositData = await depositRes.json();
          const settlementData = await settlementRes.json();
          //const balanceData = await balanceRes.json();
          const transactionWDebtIdData =  await transResWDebtID.json();
          const transactionWODebtIdData =  await transResWODebtID.json();

          setData(validateData);
          setDepositData(depositData);
          setSettlementData(settlementData);
          //setAccountBalData(balanceData);
          setTransactionDataWDebtID(transactionWDebtIdData);
          setTransactionDataWODebtID(transactionWODebtIdData);

          const allocationTransactionsWODebtID = getDebtDetailsTransactionsWODebtID(transactionWODebtIdData);
          setResultTrans(allocationTransactionsWODebtID);

          setError(null);
        } catch (err) {
            setError(err);
            Swal.fire({
              icon: "error",
              title: "We're unable to get the debt summary data.",
              text: "Kindly contact PDR Support for assistance.",
              confirmButtonColor: '#A5CC2D', 
            });
        } finally {
          setLoading(false);
        }
  
        setIsVisible(false); // Show loading data section
      };
  
      fetchData();
  }, [clientid]); // Trigger when clientid changes

  
  const totalFees = data.reduce((acc, curr) => acc + Number(curr.scheduledFee || 0), 0);
  const totalPayment = data.reduce((acc, curr) => acc + Number(curr.pendingPayment || 0), 0);

  // // If loading, show a loading message
  // if (loading) return <div className="info-badge">Loading...</div>;

  // // If there's an error, show an error message
  // if (error) return <div className="danger-badge">Unable to load Scheduled Transactions: {error}</div>;

  // Function to handle sorting
  const handleSort = (column) => {
    const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    setSortDirection(newDirection);
    setSortColumn(column);

    const sortedData = [...data].sort((a, b) => {
      if (newDirection === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });

    setData(sortedData);
  };

   useEffect(() => {
    const uniqueTrans = [...new Set(resultTrans.map(r => r.TableName).filter(Boolean))];
    console.log("Setting uniqueTableNames:", uniqueTrans);
    setUniqueTableNames(uniqueTrans);
  }, [resultTrans]);

  useEffect(() => {
    let filtered = resultTrans;
    if (selectedTableNameFilter !== "All") {
      filtered = filtered.filter(r => r.TableName === selectedTableNameFilter);
    }
    if (selectedStatusFilter !== "All") {
      filtered = filtered.filter(r => r.TransactionStatus === selectedStatusFilter);
    }
    filtered = filterByDateRange(filtered, dateFrom, dateTo);
    console.log("Setting combined filtered data:", filtered);
    setSortedData(filtered);
  }, [selectedTableNameFilter, selectedStatusFilter, dateFrom, dateTo, resultTrans]);


  useEffect(() => {

    const uniqueStats= [...new Set(resultTrans.map(r => r.TransactionStatus).filter(Boolean))];
    console.log("Setting uniqueStatuses:", uniqueStats);
    setUniqueStatuses(uniqueStats);
  }, [resultTrans]);

  return (
    <div className="debt-summary-trans-table">
      <div className="flex-container">
        <div className="column">
          <label className="container-headtitle">Debt Summary</label>
          <select
            className="form-control ddl"
            style={{
              width: '300px'
            }}
            id="ddl-calculator-type"
            value={calculatorType}
            onChange={(e) => setCalculatorType(e.target.value)}
          >
            <option value="1">Settlement Program Fee</option>
            <option value="2">Settlement Calculator</option>
          </select>
          {calculatorType === "1" && (
            <select
              className="form-control ddl"
              style={{
                width: '300px'
              }}
              id="ddl-fee-collection-type"
              value={feeCollectionType}
              //onChange={(e) => setFeeCollectionType(e.target.value)}
              onChange={(e) => {
                const selectedValue = e.target.value;
                setFeeCollectionType(selectedValue);
                //const recalculated = recalculateFees(selectedValue);
                //setResults(recalculated);
              }}
            >
              <option value="1">Collect Highest Fee</option>
              <option value="2">Collect Lowest Fee</option>
              <option value="3">Collect Equal Fee</option>
              <option value="4">Collect Priority Fee</option>
            </select>
          )}

          {calculatorType === "1" && (
            <button
              id="btn-recalculate-multiple-fees"
              onClick={() => {
                //setSelectedDebt(item);
                setIsModalRecalculationFeesOpen(true);
                setResults([]);
              }}
              className="btn btn-secondary"
            >
              Recalculate Fees
            </button>
          )}
          {isVisible && (<span className="spinner"></span>)}
          <br />
          <br />
          <br />
          <div className="table-container table-lg">
            <table className="table-bordered scrollable-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('ID')}>
                    Debt ID {sortColumn === 'ID' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('CreditorAccountNumber')}>
                    Account Number
                    {sortColumn === 'CreditorAccountNumber' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  {/* <th onClick={() => handleSort('CreditorID')}>
                  Creditor ID {sortColumn === 'CreditorID' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th> */}
                  <th onClick={() => handleSort('Creditor')}>
                  Creditor {sortColumn === 'Creditor' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('Percentage')}>
                  Fee <br/>Percent {sortColumn === 'Percentage' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('SettlementAmount')}>
                  Settlement <br/>Amount {sortColumn === 'SettlementAmount' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('CollectedPayment')}>
                  Collected <br/>Payment {sortColumn === 'CollectedPayment' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('PendingPayment')}>
                  Pending <br/>Payment {sortColumn === 'PendingPayment' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('CollectableFee')}>
                  Collectable <br/>Fee {sortColumn === 'CollectableFee' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('CollectedFee')}>
                  Collected <br/>Fee {sortColumn === 'CollectedFee' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('ScheduledFee')}>
                  Scheduled <br/>Fee {sortColumn === 'ScheduledFee' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('PendingFee')}>
                  Pending <br/>Fee {sortColumn === 'PendingFee' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th> Action </th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item) => {
                    
                    // const totalFees =+ item.pendingFee;
                    // const totalPayment =+ item.pendingPayment;
                    return (
                      <tr key={item.debtId}
                        style={{
                            backgroundColor:
                              item.settlementAmount > 0
                                ? '#ffeaeaff'      
                                : 'inherit',
                          }}
                      >
                        <td>{item.debtId}</td>
                        <td>{item.accountNumber}</td>
                        {/* <td>{item.creditorId}</td> */}
                        <td>{item.creditorName}</td>
                        <td>{item.feePercent}%</td>
                        <td style={{ color: Number(item.settlementAmount) > 0 ? "green" : "#828282" }}><strong>{formatCurrencyUSD(Number(item.settlementAmount || 0).toFixed(2))}</strong></td>
                        <td style={{ color: Number(item.collectedPayment) > 0 ? "green" : "#828282" }}><strong>{formatCurrencyUSD(Number(item.collectedPayment || 0).toFixed(2))}</strong></td>
                        <td style={{ color: Number(item.pendingPayment) > 0 ? "red" : "#828282" }}><strong>{formatCurrencyUSD(Number(item.pendingPayment || 0).toFixed(2))}</strong></td>
                        <td style={{ color: Number(item.collectableFee) > 0 ? "green" : "#828282" }}><strong>{formatCurrencyUSD(Number(item.collectableFee || 0).toFixed(2))}</strong></td>
                        <td style={{ color: Number(item.collectedFee) > 0 ? "green" : "#828282" }}><strong>{formatCurrencyUSD(Number(item.collectedFee || 0).toFixed(2))}</strong></td>
                        <td style={{ color: Number(item.scheduledFee) > 0 ? "red" : "#828282" }}><strong>{formatCurrencyUSD(Number(item.scheduledFee || 0).toFixed(2))}</strong></td>
                        <td style={{ color: Number(item.pendingFee) > 0 ? "red" : "#828282" }}><strong>{formatCurrencyUSD(Number(item.pendingFee || 0).toFixed(2))}</strong></td>
                        <td>
                          <button
                              id="btn-view"
                              onClick={() => {
                                setSelectedDebt(item);
                                setIsModalTransactionOpen(true);
                                setResults([]);
                              }}
                              className="btn btn-primary btn-sm"
                            >
                              View Transactions
                          </button>
                          {calculatorType === "1" && (
                            <button
                              id="btn-recalculate-fee"
                              onClick={() => {
                                setSelectedDebt(item);
                                setIsModalRecalculationFeeOpen(true);
                                setResults([]);
                              }}
                              className="btn btn-secondary btn-sm"
                              disabled={Number(item.scheduledFee)<= 0}
                            >
                              Recalculate Fee
                            </button>
                          )}

                          {calculatorType === "2" && (
                            <button
                              id="btn-settlement"
                              onClick={() => {
                                setSelectedDebt(item);
                                setIsModalRecalculationSettlementOpen(true);
                                setResults([]);
                              }}
                              className="btn btn-secondary btn-sm"
                            >
                              Recalculate Settlement
                            </button>
                          )}

                          <Modal isOpen={isModalTransactionOpen} onClose={() => setIsModalTransactionOpen(false)}>
                            <h2>Transaction Details</h2>

                            <div className="table-container table-xsm">
                               <table className="table-bordered scrollable-table">
                                <thead>
                                   <tr>
                                    <th> Debt ID </th>
                                    <th> Account Number </th>
                                    <th> Creditor </th>
                                    <th> Scheduled Fee </th>
                                    <th> Pending Fee </th>
                                    <th> Draft Amount Balance </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{selectedDebt?.debtId}</td>
                                    <td>{selectedDebt?.accountNumber}</td>
                                    <td>{selectedDebt?.creditorName}</td>
                                    <td>{formatCurrencyUSD(Number(selectedDebt?.scheduledFee || 0).toFixed(2))}</td>
                                    <td>{formatCurrencyUSD(Number(selectedDebt?.pendingFee || 0).toFixed(2))}</td>
                                    <td>$ {accountBalData || '0.00'}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <button className="btn btn-secondary"  onClick={handleClickTransactionsWDebtID} >View Details</button><br/><br/>
                             <Box sx={{ width: '100%' }}>
                              <Tabs value={value} onChange={handleChange} aria-label="basic tabs">
                                <Tab label="Completed Transactions" />
                                <Tab label="Scheduled Transactions" />
                                {/* <Tab label="Tab Three" /> */}
                              </Tabs>
                              <TabPanel value={value} index={0}>
                                 <div className="table-container table-sm">
                                    {results.length > 0 && (
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th onClick={() => handleSort('ID')}>
                                              Trans ID {sortColumn === 'ID' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('ScheduleDateAdjusted')}>
                                              Transaction Date{' '}
                                              {sortColumn === 'ScheduleDateAdjusted' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('TableName')}>
                                              Transaction {sortColumn === 'TableName' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('Amount')}>
                                              Amount {sortColumn === 'Amount' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('TransactionStatus')}>
                                              Status {sortColumn === 'TransactionStatus' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {results.length > 0 ? (
                                              results
                                                .filter((row) => row.TransactionStatus === "COMPLETED")
                                                .map((row) => (
                                                  <tr key={row.ID}>
                                                    <td>{row.ID || 'N/A'}</td>
                                                    <td>{row.TransactionDate || 'N/A'}</td>
                                                    <td>{row.TableName || 'N/A'}</td>
                                                    <td>{formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}</td>
                                                    <td>
                                                      <span className="badge">{row.TransactionStatus || 'N/A'}</span>
                                                    </td>
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td colSpan="5">No data available</td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                              </TabPanel>
                              <TabPanel value={value} index={1}>
                                <div className="table-container table-sm">
                                    {results.length > 0  && (
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th onClick={() => handleSort('ID')}>
                                              Trans ID {sortColumn === 'ID' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('ScheduleDateAdjusted')}>
                                              Transaction Date{' '}
                                              {sortColumn === 'ScheduleDateAdjusted' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('TableName')}>
                                              Transaction {sortColumn === 'TableName' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('Amount')}>
                                              Amount {sortColumn === 'Amount' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                            <th onClick={() => handleSort('TransactionStatus')}>
                                              Status {sortColumn === 'TransactionStatus' && (sortDirection === 'asc' ? '↑' : '↓')}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          
                                          {results.length > 0 ? (
                                              results
                                                .filter((row) => row.TransactionStatus === "SCHEDULED")
                                                .map((row) => (
                                                  <tr key={row.ID}>
                                                    <td>{row.ID || 'N/A'}</td>
                                                    <td>{row.TransactionDate || 'N/A'}</td>
                                                    <td>{row.TableName || 'N/A'}</td>
                                                    <td>{formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}</td>
                                                    <td>
                                                      <span className="badge">{row.TransactionStatus || 'N/A'}</span>
                                                    </td>
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td colSpan="5">No data available</td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                              </TabPanel>
                              {/* <TabPanel value={value} index={2}>Content for Tab Three</TabPanel> */}
                            </Box>
                           
                         </Modal>

                          <Modal isOpen={isModalRecalculationFeeOpen} onClose={() => setIsModalRecalculationFeeOpen(false)}>
                            <h2>Fee Recalculation</h2>

                            <div className="table-container table-xsm">
                               <table className="table-bordered scrollable-table">
                                <thead>
                                  <tr>
                                    <th> Debt ID </th>
                                    <th> Account Number </th>
                                    <th> Creditor </th>
                                    <th> Scheduled Fee </th>
                                    <th> Pending Fee </th>
                                    <th> Draft Amount Balance </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{selectedDebt?.debtId}</td>
                                    <td>{selectedDebt?.accountNumber}</td>
                                    <td>{selectedDebt?.creditorName}</td>
                                    <td>{formatCurrencyUSD(Number(selectedDebt?.scheduledFee || 0).toFixed(2))}</td>
                                    <td>{formatCurrencyUSD(Number(selectedDebt?.pendingFee || 0).toFixed(2))}</td>
                                    <td>$ {accountBalData || '0.00'}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <button className="btn btn-secondary"  onClick={handleClickFeeRecalculation} >Calculate</button><br/><br/>
                            
                            <div className="table-container table-sm">
                            {results.length > 0 && (
                              <table className="table-bordered scrollable-table">
                                <thead>
                                  <tr>
                                    <th onClick={() => handleSort('Month')}>
                                    Month {sortColumn === 'Month' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('FeeCollected')}>
                                    Fee Collected{' '}
                                      {sortColumn === 'Fee Collected' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('RemainingFee')}>
                                    Remaining Fee {sortColumn === 'RemainingFee' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('RemainingBal')}>
                                    Forecast Remaining Balance {sortColumn === 'RemainingBal' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('Schedule')}>
                                    Schedule {sortColumn === 'Schedule' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {results.length > 0 ? (
                                    results.map((row) => {
                                      // Ensure item has the necessary fields before rendering
                                    
                                      return (
                                      <tr key={row.month}>
                                        <td>{row.month}</td>
                                        <td>{formatCurrencyUSD(Number(row.feeCollected).toFixed(2))}</td>
                                        <td>{formatCurrencyUSD(Number(row.remainingFee).toFixed(2))}</td>
                                        <td>{formatCurrencyUSD(Number(row.remainingBalance).toFixed(2))}</td>
                                        <td>{row.scheduleDate}</td>
                                      </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td colSpan="3">No data available</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            )}
                            </div>
                        </Modal>

                        <Modal isOpen={isModalRecalculationFeesOpen} onClose={() => setIsModalRecalculationFeesOpen(false)}>
                            <h2>Multiple Fees Recalculation</h2>

                            <div className="table-container table-xsm">
                               <table className="table-bordered scrollable-table">
                                <thead>
                                  <tr>
                                    <th> Debt ID </th>
                                    <th> Account Number </th>
                                    <th> Creditor </th>
                                    <th> Scheduled Fee </th>
                                    <th> Pending Fee </th>
                                  </tr>
                                </thead>
                                <tbody>
                                 {data.length > 0 ? (
                                    data
                                      .filter(item => item.scheduledFee > 0) // ✅ Only items with pendingFee > 0
                                      .map(item => (
                                        <tr key={item.debtId}>
                                          <td>{item.debtId}</td>
                                          <td>{item.accountNumber}</td>
                                          <td>{item.creditorName}</td>
                                          <td>{formatCurrencyUSD(Number(selectedDebt?.scheduledFee || 0).toFixed(2))}</td>
                                          <td>{formatCurrencyUSD(Number(selectedDebt?.pendingFee || 0).toFixed(2))}</td>
                                        </tr>
                                      ))
                                  ) : (
                                    <tr>
                                      <td colSpan="5">No data available</td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td colSpan="5"><strong>Total Fee Outstanding:</strong> ${totalFees.toFixed(2)}</td>
                                  </tr>      
                                  <tr>
                                    <td colSpan="5"><strong>Current Draft Amount balance:</strong> ${Number(accountBalData || 0).toFixed(2)}</td>
                                  </tr>                              
                                </tbody>
                              </table>
                            </div>
                            <button className="btn btn-secondary" onClick={handleClickFeesRecalculation}>Calculate</button><br/><br/>
                            
                            <div className="table-container table-sm">
                              {results && results.length > 0 ? (
                                [...results]
                                  .filter(debtResult =>
                                    debtResult?.feeSchedule?.some(entry => entry.feeCollected > 0)
                                  )
                                  .sort((a, b) => {
                                    const feeA = parseFloat(data.find(d => d.debtId === a.debtId)?.pendingFee || 0);
                                    const feeB = parseFloat(data.find(d => d.debtId === b.debtId)?.pendingFee || 0);

                                    if (feeCollectionType === '1') return feeB - feeA;
                                    if (feeCollectionType === '2') return feeA - feeB;
                                    return 0;
                                  })
                                  .map((debtResult) => (
                                    <div key={debtResult.debtId} style={{ marginBottom: '2rem' }}>
                                      <h3 style={{ marginTop: '1rem' }}>Debt ID: {debtResult.debtId}</h3>
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th>Month</th>
                                            <th>Fee Collected</th>
                                            <th>Remaining Fee</th>
                                            <th>Forecast Remaining Balance</th>
                                            <th>Schedule</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {[...debtResult.feeSchedule]
                                            .sort((a, b) => new Date(a.scheduleDateObj) - new Date(b.scheduleDateObj)) // Optional: sort rows by schedule date
                                            .map((row, idx) => (
                                              <tr key={`${debtResult.debtId}-${row.month}-${idx}`}>
                                                <td>{row.month}</td>
                                                <td>{formatCurrencyUSD(Number(row.feeCollected).toFixed(2))}</td>
                                                <td>{formatCurrencyUSD(Number(row.remainingFee).toFixed(2))}</td>
                                                <td>{formatCurrencyUSD(Number(row.remainingBalance).toFixed(2))}</td>
                                                <td>{row.scheduleDate}</td>
                                              </tr>
                                            ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))
                              ) : (
                                <p>No data available</p>
                              )}
                            </div>

                        </Modal>

                        <Modal isOpen={isModalRecalculationSettlementOpen} onClose={() => setIsModalRecalculationSettlementOpen(false)}>
                            <h2>Settlement Recalculation</h2>

                            <div className="table-container table-xsm">
                               <table className="table-bordered scrollable-table">
                                <thead>
                                   <tr>
                                    <th> Debt ID </th>
                                    <th> Account Number </th>
                                    <th> Creditor </th>
                                    <th> Scheduled Fee </th>
                                    <th> Pending Fee </th>
                                    <th> Draft Amount Balance </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{selectedDebt?.debtId}</td>
                                    <td>{selectedDebt?.accountNumber}</td>
                                    <td>{selectedDebt?.creditorName}</td>
                                    <td>{formatCurrencyUSD(Number(selectedDebt?.scheduledFee || 0).toFixed(2))}</td>
                                    <td>{formatCurrencyUSD(Number(selectedDebt?.pendingFee || 0).toFixed(2))}</td>
                                    <td>{formatCurrencyUSD(Number(accountBalData || '0.00').toFixed(2))}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <button className="btn btn-secondary"  onClick={handleClick} >Calculate</button><br/><br/>
                            
                            <div className="table-container table-sm">
                            {results.length > 0 && (
                              <table className="table-bordered scrollable-table">
                                <thead>
                                  <tr>
                                    <th onClick={() => handleSort('Month')}>
                                    Month {sortColumn === 'Month' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('FeeCollected')}>
                                    Fee Collected{' '}
                                      {sortColumn === 'Fee Collected' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('RemainingFee')}>
                                    Remaining Fee {sortColumn === 'RemainingFee' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('RemainingBal')}>
                                    Remaining Balance {sortColumn === 'RemainingBal' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('Schedule')}>
                                    Schedule {sortColumn === 'Schedule' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {results.length > 0 ? (
                                    results.map((row) => {
                                      // Ensure item has the necessary fields before rendering
                                    
                                      return (
                                      <tr key={row.month}>
                                        <td>{row.month}</td>
                                        <td>{formatCurrencyUSD(Number(row.feeCollected).toFixed(2))}</td>
                                        <td>{formatCurrencyUSD(Number(row.remainingFee).toFixed(2))}</td>
                                        <td>{formatCurrencyUSD(Number(row.remainingBalance).toFixed(2))}</td>
                                        <td>{row.scheduleDate}</td>
                                      </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td colSpan="3">No data available</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            )}
                            </div>
                        </Modal>


                        </td>
                      </tr>
                     
                    );
                   
                  })
                ) : (
                  <tr>
                    <td colSpan="13">No data available</td>
                  </tr>
                )}
                 <tr>
                  <td colSpan="12"  style={{fontSize: '1.5em'}}><strong>Total Fee Outstanding:</strong> {formatCurrencyUSD(Number(totalFees.toFixed(2)))}</td>
                </tr>
                <tr>
                  <td colSpan="12"  style={{fontSize: '1.5em'}}><strong>Total Payment Outstanding:</strong> {formatCurrencyUSD(Number(totalPayment.toFixed(2)))}</td>
                </tr>
              </tbody>
            </table>
            <br/><br/><br/>
          </div>
            

          {/* <button className="btn btn-secondary"  onClick={handleClickTransactionsWODebtID} >View Transaction Details</button><br/><br/> */}
          <Box sx={{ width: '100%' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs">
              <Tab label="All Transactions Without Debt ID" />
              {/* <Tab label="Tab Three" /> */}
            </Tabs>
            <TabPanel value={value} index={0}>

               <TableNameFilterDropdown
                selectedFilter={selectedTableNameFilter}
                onChange={setSelectedTableNameFilter}
                options={["All", ...uniqueTableNames]}
              />

              <StatusFilterDropdown
                selectedFilter={selectedStatusFilter}
                onChange={setSelectedStatusFilter}
                options={["All", ...uniqueStatuses]}
              />

              <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '140px', marginBottom: '10px', marginLeft: '10px' }}>
                <label style={{ fontSize: '1em', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                  [Cleared Date] From 
                </label>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                  style={{
                    border: '1px solid #D1D5DB',
                    borderRadius: '7px',
                    padding: '10px',
                    fontSize: '1em',
                    backgroundColor: 'white',
                    width: '150px'
                  }}
                />
              </div>

              <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '140px', marginBottom: '10px', marginLeft: '10px' }}>
                <label style={{ fontSize: '1em', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                  [Cleared Date] To 
                </label>
                <input
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  style={{
                    border: '1px solid #D1D5DB',
                    borderRadius: '7px',
                    padding: '10px',
                    fontSize: '1em',
                    backgroundColor: 'white',
                    width: '150px'
                  }}
                />
              </div>
                
              <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '100px', marginBottom: '10px', marginLeft: '10px' }}>
                <button
                  className="btn"
                  style={{ marginLeft: '10px', height: '40px', alignSelf: 'flex-end', position: 'relative', top: '30px', backgroundColor: '#fc8484ff' }}
                  onClick={clearFilters}
                >
                  Clear Filters
                </button>
              </div>

                <div className="table-container table-sm">
                  {sortedData.length > 0 && (
                    <table className="table-bordered scrollable-table">
                      <thead>
                        <tr>
                          <th onClick={() => handleSort('CounterID')} title="Sort by Item #">Item # {sortColumn === 'CounterID' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('DebtID')} title="Sort by Debt ID">Debt ID {sortColumn === 'DebtID' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('TransID')} title="Sort by Trans ID ">Trans ID {sortColumn === 'TransID' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('ProcessDate')} title="Sort by Process Date">Process Date {sortColumn === 'ProcessDate' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('ClearedDate')} title="Sort by Cleared Date">Cleared Date {sortColumn === 'ClearedDate' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('Transaction')} title="Sort by Transaction">Transaction {sortColumn === 'Transaction' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('Amount')} title="Sort by Amount">Amount {sortColumn === 'Amount' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('Status')} title="Sort by Status">Status {sortColumn === 'Status' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.length > 0 ? (
                            sortedData
                              .map(row => (
                                <tr
                                  key={row.CounterID}
                                  style={{
                                    backgroundColor:
                                      row.EndingBalance < 0 ?  '#ffeaeaff' : 'inherit',
                                  }}
                                >
                                  <td>{row.CounterID}</td>
                                  <td>{row.DebtID || 'N/A'}</td>
                                  <td>{row.TransID || 'N/A'}</td>
                                  <td>{row.ProcessDate || 'N/A'}</td>
                                  <td>{row.ClearedDate || 'N/A'}</td>
                                  <td>{row.TableName || 'N/A'}</td>
                                  <td>
                                    <span
                                      style={{
                                        color: row.Type === "credit" ? 'red' : 'green',
                                      }}
                                    >
                                    {row.Type === "credit" ? '-' : '+'} {formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className="badge"
                                      style={{
                                        backgroundColor:
                                          row.TransactionStatus?.toUpperCase() === 'COMPLETED'
                                          ? '#b7ffd8ff'
                                          : row.TransactionStatus?.toUpperCase() === 'SCHEDULED'
                                          ? '#ffebb7ff'
                                          : 'inherit',
                                      }}
                                    >
                                      {row.TransactionStatus || 'N/A'}
                                    </span>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="8">No data available</td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  )}
                </div>
            </TabPanel>
          </Box>
        </div>
      </div>
      {/* <div style={{ padding: '20px' }}>
        <h1>React Modal Example</h1>
        <button onClick={() => setIsModalOpen(true)}>Open Modal</button>

        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <h2>Modal Title</h2>
          <p>This is the content inside the modal!</p>
        </Modal>
      </div> */}
    </div>
  );
};

export default ClientDebtSummary;
